import axios from '../../helpers/Axios'
import { PatientRecordedEcgArrhythmiaWindowType } from './types'
import { ECG_ARRHYTHMIA_API_BASE_URL } from '../../constants/apiConstants'

const baseUrl = ECG_ARRHYTHMIA_API_BASE_URL

export const getRecordedEcgArrhythmiaWindow = async (
  patientKey: string,
  startTime: number,
  endTime: number
): Promise<PatientRecordedEcgArrhythmiaWindowType[]> => {
  const roundedStartTime = Math.round(startTime / 1000)
  const roundedEndTime = Math.round(endTime / 1000)
  return axios({
    method: 'get',
    baseURL: baseUrl,
    url: `/api/ecg-windows/${patientKey}/${roundedStartTime}/${roundedEndTime}`,
  })
}
